var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLorus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 555,
    height: 745,
    viewBox: "0 0 555 745",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.98 -363L555 1077.27L0.796689 1077.28C0.655584 1019.72 -0.153191 959.451 0.77239 902.085C0.326397 885.937 0.636249 868.328 0.653047 852.079C0.568216 837.124 0.611979 822.178 0.785001 807.223C0.121472 788.933 0.733713 766.551 0.730353 747.765L0.717742 630.177C-0.247315 592.042 0.212158 545.825 0.781617 507.539C-0.535362 452.551 0.724446 391.766 0.722766 336.376L0.784078 11.0067C0.587539 -1.84015 0.561526 -14.6887 0.704311 -27.5355L0.72779 -362.987L554.98 -363Z",
    fill: "url(#paint0_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.19219 302.954C67.2499 305.68 113.544 353.766 110.615 419.391C109.113 447.737 96.4813 474.354 75.4684 493.442C55.7768 511.438 29.0198 522.209 2.27031 521.906C1.21119 524.41 1.33801 523.335 1.73696 525.973L3.22111 526.427C20.0319 542.247 36.5605 560.94 53.3528 576.155L52.1811 577.491L52.8295 579.676C51.374 583.129 8.89214 625.481 3.13539 630.304L3.17907 630.959L0.717321 630.177C-0.247736 592.043 0.211686 545.826 0.781145 507.54C2.05781 503.625 1.25905 475.169 1.44635 469.943C2.05528 452.997 0.161285 307.378 2.19219 302.954Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3535 576.155L52.1819 577.491L52.8303 579.675L50.4264 579.515C46.4176 577.6 11.6562 579.12 3.70983 578.566L4.04745 577.448C2.17109 574.525 2.62215 531.887 3.22184 526.426C20.0326 542.246 36.5612 560.939 53.3535 576.155Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1817 577.491L52.8301 579.676L50.4263 579.516C46.4174 577.6 11.656 579.121 3.70964 578.567L4.04726 577.449C18.6659 577.113 37.7016 576.827 52.1817 577.491Z",
    fill: "url(#paint1_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8301 579.675C51.3745 583.128 8.89269 625.481 3.13594 630.303C2.39094 615.382 2.98311 595 2.98395 579.675C18.7986 579.7 34.6124 579.65 50.4263 579.516L52.8301 579.675Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04679 577.449L3.70917 578.567C11.6556 579.121 46.4169 577.601 50.4258 579.516C34.612 579.651 18.7981 579.701 2.98347 579.676C2.98263 595 2.39047 615.382 3.13547 630.304L3.17915 630.959L0.717396 630.177C-0.24766 592.043 0.211761 545.826 0.78122 507.54C2.05788 503.625 1.25912 475.169 1.44642 469.943C2.05536 452.997 0.16136 307.378 2.19226 302.954C3.44961 308.047 3.52018 517.546 2.27039 521.906C1.21126 524.41 1.33808 523.335 1.73704 525.973L3.22118 526.427C2.62149 531.888 2.17043 574.525 4.04679 577.449Z",
    fill: "url(#paint2_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.756 81.3086C111.225 82.6226 111.535 83.1712 111.548 85.6354C111.655 107.113 111.584 128.985 111.565 150.44C74.8001 149.683 120.921 182.738 84.4767 182.263C80.8777 182.216 81.5681 189.739 78.6074 189.754C62.7852 190.701 43.2018 190.154 27.467 190.023C31.2457 185.551 35.0354 181.378 37.8332 176.214C34.0863 178.004 27.4325 186.498 24.5424 190.043L2.89207 190.103C2.89543 167.775 3.74123 139.641 2.83496 117.819C3.19781 106.353 2.92398 93.3506 2.95169 81.7589C35.085 81.5136 78.7032 83.1099 109.756 81.3086Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9553 129.192C76.6003 139.005 75.8192 149.488 69.5997 157.558C63.2206 165.835 53.2525 168.938 43.3096 170.271C42.7511 159.956 43.2895 149.52 50.1129 141.135C56.4744 133.318 66.2527 130.196 75.9553 129.192Z",
    fill: "url(#paint3_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8083 141.999C61.8092 142.126 61.8167 142.253 61.8092 142.379C61.7974 142.587 61.768 142.794 61.7487 143.002C61.7017 143.512 61.7227 143.518 61.6135 144.057C60.6652 148.741 49.3433 162.212 45.609 164.621L44.9421 162.014C45.0765 160.92 45.2285 159.829 45.3973 158.741C46.6194 150.936 50.4905 142.017 57.0192 137.238C59.0921 136.804 59.1534 136.621 60.9113 137.75L61.8083 141.999Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8469 133.406C73.9923 140.273 72.8576 145.827 70.7359 152.354C66.5691 153.054 62.2973 153.436 58.1011 153.956C61.5549 146.877 68.8881 139.597 73.8469 133.406Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7402 155.255C63.1204 162.522 56.1844 165.202 47.5569 167.405C49.5878 163.582 53.023 159.972 55.7325 156.57C60.0623 155.913 64.3752 155.567 68.7402 155.255Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4443 132.108C69.447 135.782 66.5452 139.045 63.7768 142.147C63.3048 139.757 62.6253 137.5 63.5475 135.145C65.3584 132.946 68.786 132.677 71.4443 132.108Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.165 745.622C125.515 756.771 113.06 771.062 111.207 798.779C93.1234 798.804 72.522 799.3 54.6395 798.628L55.2871 800.812L54.8092 801.636C53.2797 801.4 53.5199 801.669 52.549 800.796C36.0221 800.695 19.4952 800.695 2.96828 800.804C2.9834 817.624 2.49791 837.157 3.05225 853.751L2.06788 853.574L0.653456 852.079C0.568625 837.124 0.612337 822.177 0.785358 807.223C1.9268 805.332 1.3212 702.153 1.44887 690.668L3.20343 690.071C9.31378 696.171 54.406 740.304 54.9402 743.278L55.7641 745.354C86.2873 745.564 120.108 744.555 150.165 745.622Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.20266 690.071C9.313 696.171 54.4053 740.304 54.9395 743.278L2.96494 743.152C2.93975 730.029 2.14605 701.934 3.20266 690.071Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.639 798.628L55.2866 800.812L54.8087 801.636C53.2792 801.4 53.5194 801.669 52.5485 800.796C36.0216 800.695 19.4947 800.695 2.96781 800.804C2.98293 817.624 2.49744 837.157 3.05178 853.751L2.06741 853.574L0.65298 852.079C0.568149 837.124 0.61186 822.177 0.784882 807.223C1.92632 805.332 1.32073 702.153 1.44839 690.668L3.20296 690.071C2.14635 701.934 2.94005 730.029 2.96524 743.152L54.9398 743.278L55.7637 745.354L2.97616 745.48L2.98037 798.687C9.34185 798.737 48.3952 799.409 52.5863 798.426L54.639 798.628Z",
    fill: "url(#paint4_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.83 79.6495C106.39 79.9209 108.242 80.7291 109.756 81.3088C78.7035 83.1101 35.0853 81.5138 2.95203 81.7592C2.92431 93.3508 3.19814 106.353 2.8353 117.82C-2.34611 111.544 5.28698 22.6869 0.784225 11.007C0.587686 -1.8398 0.561674 -14.6883 0.704458 -27.5352L3.20486 -27.2613L74.6669 44.2764C83.5675 53.2123 100.45 69.0854 108.19 77.9675L107.742 79.0782L104.83 79.6495Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.83 79.6495C106.39 79.9209 108.242 80.7291 109.756 81.3088C78.7035 83.1101 35.0853 81.5138 2.95203 81.7592C2.92431 93.3508 3.19814 106.353 2.8353 117.82C-2.34611 111.544 5.28698 22.6869 0.784225 11.007C0.587686 -1.8398 0.561674 -14.6883 0.704458 -27.5352L3.20486 -27.2613C2.00295 6.25258 2.94282 45.461 2.94618 79.3992L104.83 79.6495Z",
    fill: "url(#paint5_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1712 582.062C56.7242 587.581 55.8809 624.027 55.9321 632.589C39.1398 632.589 21.2606 632.899 4.55732 632.53C20.8549 616.256 38.8441 598.982 54.5471 582.33L55.1712 582.062Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7904 574.937C49.303 571.274 11.948 531.627 4.84736 524.401C21.2382 523.965 39.3979 524.326 55.9298 524.309C56.0172 541.188 55.971 558.058 55.7904 574.937Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6482 582.254C63.574 587.312 75.6418 599.065 80.7628 604.014C90.1933 613.113 100.128 623.749 109.622 632.554L58.196 632.604L58.2406 582.43L59.6482 582.254Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.868 579.575C110.86 595.328 111.425 615.206 110.759 630.614C104.612 624.506 62.4628 583.624 60.9065 579.55C77.3074 579.55 94.5381 579.272 110.868 579.575Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.477 524.342C92.6565 540.961 75.9499 557.688 59.3583 574.542L58.3151 574.592C57.7238 559.016 58.1958 540.137 58.1799 524.309L109.477 524.342Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3589 574.542C59.6058 577.357 61.1278 577.289 60.9069 579.549C60.6196 580.196 59.9754 581.734 59.6486 582.255L58.241 582.431C56.7737 582.423 56.5855 582.423 55.172 582.061L54.5479 582.33C54.1237 581.65 53.2847 580.23 52.8303 579.675L52.1819 577.491L53.3535 576.155L55.791 574.937L58.3157 574.592L59.3589 574.542Z",
    fill: "url(#paint6_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.107 -139.69L332.102 853.953C318.634 853.995 231.844 855.617 224.02 853.298L222.57 851.777L221.455 853.693C209.138 853.802 196.82 853.76 184.503 853.575C202.753 846.602 214.327 836.116 221.002 817.381C223.566 815.81 223.256 808.744 223.83 805.325C224.072 803.359 223.904 798.956 223.882 796.797C222.974 791.378 223.937 785.069 220.986 782.304C220.644 781.271 220.282 780.246 219.899 779.229C213.239 761.578 201.068 752.983 184.711 745.64C196.67 745.144 210.263 745.447 222.341 745.447L223.472 744.455L223.127 742.708L222.161 743.027C209.289 744.061 184.47 743.153 171.071 742.893C211.179 706.875 209.808 671.009 170.84 635.059C185.078 634.403 207.987 634.412 222.183 635.033L223.167 635.319L223.481 633.571L222.361 632.588L113.685 632.58L113.831 413.618H222.334L223.473 412.593L223.195 410.838L222.207 411.031C207.032 411.787 184.02 411.694 168.715 411.106L220.705 359.109L219.074 357.924L219.323 355.681L220.687 354.371L169.467 303.129C186.695 302.732 205.01 303.016 222.319 303.007L223.488 301.693L222.26 300.848C193.117 300.494 162.894 301.326 133.979 300.506C179.088 290.061 208.852 261.321 220.95 216.587L221.453 214.784L222.461 216.408C222.747 211.059 222.912 204.771 223.814 199.575C224.156 195.243 223.952 190.473 223.878 186.1C223.358 183.131 223.026 168.548 222.359 167.722L220.676 168.155C220.603 167.161 220.477 166.714 220.898 165.802C209.344 121.623 179.131 92.5164 134.815 82.059C160.838 80.9886 195.16 81.3079 221.379 81.8641L222.229 82.5874L223.426 81.6817L223.081 78.7739L221.882 77.9246C207.39 64.062 184.245 41.6063 171.008 27.0161L169.191 28.7048L168.491 29.4904L166.316 29.1257L164.917 29.072L163.569 27.1446L162.592 26.2179L161.943 24.4536L163.805 23.4421C166.013 22.633 166.62 22.3751 168.998 22.1054L169.744 21.0165L170.799 23.5311C185.103 9.11738 206.467 -13.7357 221.425 -26.8153C221.018 -27.5378 222.859 -27.0833 223.564 -30.1801L222.362 -31.179C215.254 -30.9866 201.16 -28.8526 196.899 -35.8982C192.031 -43.9469 203.143 -45.5978 204.038 -48.7661C193.277 -55.2453 192.813 -61.1071 204.483 -66.7975C200.863 -69.1592 195.337 -72.0669 195.991 -77.1155C196.585 -81.7111 201.002 -82.6563 204.209 -85.2591C195.515 -92.7163 190.391 -95.53 203.932 -103.456C203.683 -106.028 199.442 -105.657 196.627 -110.132C194.378 -117.389 199.05 -119.118 204.234 -122.216C200.539 -125.093 196.953 -127.451 195.577 -132.005C196.924 -142.397 213.818 -139.581 221.522 -139.202L223.612 -138.877C232.665 -141.337 318.024 -139.898 332.107 -139.69Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.334 413.618C220.931 419.289 221.022 628.497 222.361 632.588L113.685 632.58L113.831 413.618H222.334Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.815 199.575L223.903 572.282V721.796C223.906 745.901 224.546 773.08 223.883 796.797C222.974 791.378 223.938 785.069 220.987 782.305C220.644 781.271 220.282 780.246 219.899 779.23C213.24 761.578 201.069 752.983 184.711 745.64C196.671 745.144 210.263 745.447 222.342 745.447L223.472 744.456L223.128 742.708L222.161 743.027C209.29 744.061 184.47 743.153 171.072 742.893C211.18 706.875 209.809 671.009 170.84 635.059C185.078 634.403 207.988 634.412 222.184 635.033L223.168 635.319L223.482 633.572L222.362 632.589C221.022 628.497 220.932 419.29 222.334 413.619L223.474 412.594L223.196 410.838L222.208 411.031C207.033 411.787 184.021 411.695 168.715 411.106L220.706 359.109L219.075 357.925L219.324 355.681L220.687 354.371L169.468 303.129C186.695 302.732 205.01 303.016 222.32 303.007L223.488 301.693L222.26 300.848C193.118 300.494 162.895 301.327 133.979 300.506C179.088 290.061 208.853 261.321 220.95 216.588L221.454 214.784L222.462 216.408C222.748 211.059 222.912 204.771 223.815 199.575Z",
    fill: "url(#paint7_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.184 635.033C220.802 641.636 221.036 738.985 222.161 743.026C209.289 744.06 184.47 743.152 171.072 742.892C211.179 706.875 209.808 671.008 170.84 635.058C185.078 634.403 207.987 634.411 222.184 635.033Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.95 216.587C223.204 230.633 220.413 264.623 221.373 280.523C221.778 287.234 220.808 293.737 222.26 300.847C193.117 300.493 162.894 301.326 133.979 300.505C179.088 290.06 208.852 261.32 220.95 216.587Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.705 359.109C223.326 363.957 219.893 400.857 222.207 411.031C207.032 411.787 184.021 411.695 168.715 411.107L220.705 359.109Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.319 303.007C219.7 312.974 223.432 349.338 220.687 354.371L169.467 303.129C186.695 302.732 205.01 303.016 222.319 303.007Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.379 81.864C221.56 100.199 221.616 118.534 221.545 136.87C221.542 142.837 221.826 160.91 220.898 165.801C209.344 121.623 179.131 92.5163 134.815 82.0589C160.838 80.9885 195.16 81.3078 221.379 81.864Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.036 24.3577L222.961 25.3314L221.821 26.2136C215.988 26.1766 173.47 25.3104 171.007 27.0159L169.191 28.7047L168.491 29.4902L166.316 29.1256L164.916 29.0718L163.569 27.1445L162.592 26.2178L161.943 24.4535L163.805 23.4419C166.013 22.6329 166.62 22.3749 168.998 22.1052L169.744 21.0164L170.799 23.531C185.103 9.11722 206.467 -13.7359 221.425 -26.8154C221.458 -18.1232 221.064 19.3083 222.036 24.3577Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.036 24.3579L222.961 25.3316L221.821 26.2138C215.988 26.1768 173.47 25.3106 171.007 27.0162L169.191 28.7049L168.491 29.4904L166.316 29.1258L164.916 29.072L163.569 27.1447L162.592 26.218L161.943 24.4537L163.805 23.4422C166.013 22.6331 166.62 22.3752 168.998 22.1055L169.744 21.0166L170.799 23.5312C174.05 25.0275 214.922 24.1512 222.036 24.3579Z",
    fill: "url(#paint8_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.821 26.2134C221.023 30.5217 221.455 72.5086 221.882 77.9242C207.39 64.0616 184.245 41.6059 171.008 27.0158C173.47 25.3102 215.988 26.1764 221.821 26.2134Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.612 -138.877C224.317 -128.41 223.936 -114.311 223.924 -103.631L223.88 -43.8864C223.883 -4.25617 225.152 42.5851 223.864 81.8582L223.426 81.6817L223.081 78.774L221.882 77.9246C221.455 72.5089 221.023 30.5221 221.821 26.2138L222.961 25.3316L222.036 24.3579C221.064 19.3085 221.458 -18.123 221.425 -26.8152C221.017 -27.5378 222.859 -27.0833 223.564 -30.1801L222.362 -31.179C219.649 -40.7442 221.494 -123.113 221.522 -139.202L223.612 -138.877Z",
    fill: "url(#paint9_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.864 81.8581C223.918 114.884 224.924 153.588 223.878 186.1C223.359 183.131 223.026 168.548 222.359 167.722L220.676 168.155C220.603 167.161 220.477 166.714 220.898 165.802C221.827 160.91 221.543 142.837 221.545 136.87C221.616 118.534 221.56 100.199 221.379 81.864L222.229 82.5873L223.427 81.6816L223.864 81.8581Z",
    fill: "url(#paint10_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.383 376.021C290.802 380.667 289.573 385.717 286.179 389.186C282.785 392.656 277.767 393.992 273.096 392.673C268.424 391.362 264.844 387.599 263.761 382.86C262.167 375.895 266.371 368.922 273.273 367.082C280.174 365.234 287.295 369.191 289.383 376.021Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.722 418.348C289.622 421.801 289.657 425.027 286.722 427.279C283.988 428.262 282.923 427.783 280.064 427.044C278.854 423.851 278.203 422.154 279.335 419.23C281.816 417.651 286.572 418.247 289.722 418.348Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.395 27.1206C283.831 28.7371 276.85 32.7396 273.969 31.7625L273.247 29.5764C273.415 26.2822 272.916 25.4235 274.581 23.0366C278.146 22.6905 282.623 25.442 286.395 27.1206Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.709 616.668C293.224 621.112 293.557 626.842 290.932 630.673C288.405 631.908 289.427 631.841 287.036 631.236C287.423 629.413 289.507 622.271 289.421 621.104C288.13 603.687 264.074 602.847 263.723 624.204C264.994 626.884 266.871 629.236 264.932 631.631C256.286 627.581 259.875 610.921 269.135 606.317C273.183 604.334 277.863 604.082 282.1 605.619C288.013 607.728 290.297 611.383 292.709 616.668Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.109 524.343L553.089 743.178C505.102 744.262 456.374 742.557 408.302 743.246C384.781 743.59 360.141 743.725 336.67 742.968C356.489 726.644 376.416 710.446 396.449 694.382C396.496 700.104 396.178 710.656 404.496 711.076C406.4 711.168 408.253 710.446 409.601 709.102C411.21 707.489 411.871 705.707 411.8 703.473C411.821 694.836 413.103 699.549 418.754 694.046C423.081 689.837 421.964 682.023 421.771 676.016C432.599 673.588 435.412 671.538 438.031 660.364L470.629 633.672C426.001 598.344 380.656 560.461 336.512 524.36C407.763 523.469 481.774 524.124 553.109 524.343Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.655 628.127C536.144 645.518 529.841 645.905 516.649 637.68C516.604 640.393 516.834 644.468 515.428 646.569C514.064 643.309 514.43 638.688 514.448 635.042L490.382 634.991L488.511 634.185L489.087 633.311C494.594 632.429 508.253 632.731 514.474 632.731C514.42 629.211 514.076 623.842 515.513 620.742C516.824 622.859 516.603 627.304 516.686 629.984C523.086 625.539 528.643 620.91 534.655 628.127Z",
    fill: "url(#paint11_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.843 629.513C532.974 632.815 533.391 635.738 531.903 638.687C527.03 643.039 522.974 639.074 518.393 635.94L517.31 634.327C518.629 629.286 527.793 623.472 532.843 629.513Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.106 303.081L553.08 521.847L444.93 521.839L444.926 303.12C480.985 302.849 517.047 302.835 553.106 303.081Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.581 231.837L111.555 300.667C75.3894 301.425 39.0783 300.695 2.89334 300.75L2.90846 236.589L2.88831 192.302L25.051 192.27C28.8138 196.983 32.4027 201.972 37.2902 205.583L37.134 204.317L36.315 204.682L35.8237 204.206L36.3999 203.041C34.1808 199.254 30.7733 195.739 27.9588 192.344C36.9786 192.261 72.988 190.613 79.1958 192.699C81.8021 193.574 80.6539 199.06 84.8198 200.185C88.5112 201.182 94.6645 199.8 97.5151 202.755C102.256 207.666 96.6483 217.609 96.4787 223.579C96.4174 225.743 96.9793 227.793 98.5407 229.346C101.899 232.686 107.248 231.907 111.581 231.837Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9594 241.652C76.282 245.5 76.0291 249.585 76.0233 253.457C69.2712 251.944 62.5292 250.535 56.5995 246.776C48.4927 241.635 45.4631 234.448 43.3482 225.493C42.9652 220.986 43.1954 216.439 43.2945 211.922C50.5631 212.924 58.0324 214.77 64.0461 219.188C71.8943 224.953 74.4955 232.492 75.9594 241.652Z",
    fill: "url(#paint12_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8691 237.024L60.7529 246.79C52.3286 241.945 48.512 236.163 45.9016 226.932C45.5026 224.239 44.8089 221.346 45.6454 218.693L46.8725 218.582C52.3991 222.598 57.4537 231.483 61.8691 237.024Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4327 239.374C73.7376 241.656 74.2458 244.762 72.9296 246.614C69.1047 244.98 64.3239 236.817 61.7135 233.451L57.7357 228.262C62.052 228.568 66.3532 229.227 70.6426 229.786C71.8588 232.914 72.6298 236.124 73.4327 239.374Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9609 225.727C67.8005 225.882 67.651 226.049 67.4797 226.192C65.7671 227.622 58.2113 226.107 55.8494 225.839L48.3297 216.193L49.157 215.43C56.0124 215.567 63.3482 221.034 67.9609 225.727Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.249 249.156C70.7778 249.327 70.7862 249.349 70.1991 249.418C68.1716 249.654 65.8971 249.249 64.3307 247.924C62.9541 245.343 63.1179 244.413 63.3018 241.485L63.9922 240.899C66.7362 242.115 69.397 246.737 71.249 249.156Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.221 633.983C464.585 636.445 441.853 654.365 437.909 657.524C434.132 647.4 432.352 651.097 427.06 643.872C426.941 641.007 428.425 634.529 425.698 632.437C400.359 613.013 407.339 662.288 406.485 675.092C396.544 678.99 396.59 681.393 396.581 691.172C377.694 707.539 353.87 726.333 334.178 741.985L334.142 723.88L334.162 585.086C377.641 601.746 422.475 617.785 466.221 633.983Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.684 245.455C375.902 229.36 380.998 216.044 393.592 205.305C404.698 195.886 419.128 191.336 433.626 192.682C448.093 193.958 461.444 200.985 470.689 212.188C479.749 223.097 484.084 237.17 482.731 251.287C481.383 265.83 474.272 279.229 462.984 288.495C451.814 297.64 437.44 301.913 423.09 300.354C408.816 298.903 395.727 291.767 386.771 280.555C378.898 270.758 375.342 259.992 374.644 247.581C381.186 247.419 395.842 246.326 401.322 248.816L403.342 247.626L403.013 245.542C406.339 241.703 425.404 223.328 426.049 220.956L425.066 220.554C419.336 225.011 405.392 239.661 399.624 245.426L374.684 245.455Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.013 245.541C407.948 245.451 441.336 244.735 443.906 246.155L443.658 247.087C437.497 248.029 410.995 247.601 403.342 247.626L403.013 245.541Z",
    fill: "url(#paint13_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.342 247.626C410.335 256.05 419.732 263.753 426.395 271.781L425.995 272.23C421.158 269.544 404.011 253.182 401.322 248.816L403.342 247.626Z",
    fill: "url(#paint14_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.181 793.604C221.922 808.5 219.693 820.649 210.334 832.806C201.64 844.157 188.764 851.542 174.582 853.331C160.083 855.272 145.413 851.264 133.913 842.224C119.724 831.017 115.116 817.969 113.107 800.763L138.148 800.746C142.435 805.073 160.535 823.632 164.305 826.009C164.186 822.094 145.487 804.871 141.365 800.779L178.821 800.737C180.474 799.964 179.795 801.149 181.872 800.359L181.674 799.46L180.181 799.586C178.738 798.427 145.816 798.704 141.394 798.679C147.062 792.941 161.501 780.011 164.367 773.878L163.688 773.71C155.565 780.893 145.984 790.975 138.162 798.78L113.08 798.746C114.311 786.698 116.608 777.524 123.956 767.576C132.515 755.965 145.356 748.261 159.623 746.169C173.922 744.06 188.469 747.749 200.039 756.419C212.439 765.745 219.016 778.44 221.181 793.604Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.107 192.488L553.082 300.701C517.831 300.738 481.339 301.206 446.195 300.517C456.477 296.344 461.568 293.012 469.542 285.513C474.596 280.096 478.587 273.775 481.307 266.883C486.701 252.868 486.319 237.286 480.245 223.552C473.195 207.794 461.69 198.739 445.967 192.677C478.579 191.28 519.814 192.329 553.107 192.488Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.025 214.474C532.564 224.352 527.128 223.525 524.609 229.231C526.352 231.356 528.016 233.544 529.596 235.791C531.666 238.739 532.269 239.911 531.659 243.328L530.375 243.013L530.051 240.956C526.715 232.75 523.051 231.834 515.188 229.319C531.999 224.424 524.15 221.54 532.025 214.474Z",
    fill: "url(#paint15_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.218 260.693C515.573 265.612 513.081 267.667 510.01 271.478C512.501 274.479 515.677 277.159 514.623 281.658L513.53 281.36L513.056 279.329C511.292 276.072 509.333 274.364 505.976 272.772L505.393 272.501L505.981 271.362L505.081 271.804C508.575 269.074 512.415 266.547 513.405 262.227C513.532 261.672 514.588 261.135 515.218 260.693Z",
    fill: "url(#paint16_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.121 181.164C221.299 183.207 221.426 185.252 221.501 187.301C222.577 216.411 211.943 244.74 191.978 265.947C170.914 288.342 144.303 299.271 113.869 300.201C113.662 292.897 113.288 287.789 116.211 280.851C120.462 270.764 123.614 261.69 125.61 250.902C135.626 267.103 138.139 273.053 152.697 287.904C152.579 270.201 150.26 259.335 145.618 242.517C158.602 251.394 165.826 254.529 180.573 259.111C176.004 244.301 172.263 236.878 164.115 224.149C179.907 228.962 192.863 231.069 209.236 231.272C198.975 220.332 185.179 211.207 171.976 204.204C183.287 202.149 189.179 200.152 199.556 195.828C201.972 194.638 205.227 193.389 206.694 191.256C203.466 185.458 178.799 179.443 172.083 178.2C185.747 171.158 198.239 162.043 209.117 151.18C191.706 151.172 180.854 153.637 164.412 157.983C172.59 144.922 176.046 137.67 180.489 123.302C167.014 127.128 157.127 131.884 145.714 139.855C150.128 123.135 152.559 112.313 152.652 94.6726C142.013 104.297 132.308 119.082 125.735 131.838C123.08 116.734 118.106 108.424 113.972 94.124C113.599 92.8327 113.793 83.9657 113.839 82.1602C170.989 83.354 214.824 124.633 221.121 181.164Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.163 -27.7637L406.98 45.0813C413.516 51.6219 435.493 72.6964 440.102 78.906L438.858 79.4101C407.097 80.5796 366.504 79.6369 334.187 79.3874C333.803 43.8983 334.154 7.7758 334.163 -27.7637Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.02 520.739C436.728 523.377 346.211 521.865 334.187 521.848L334.136 416.904L334.759 416.03C337.901 417.425 428.864 509.59 440.02 520.739Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.251 -28.9156L442.178 77.5012C424.589 59.4378 406.182 41.3996 388.334 23.5329C370.921 6.19119 353.602 -11.2446 336.378 -28.7736C369.272 -29.9734 408.855 -29.0189 442.251 -28.9156Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.286 413.601L442.199 519.89L389.668 467.329L336.156 413.643C370.881 413.005 407.417 413.551 442.286 413.601Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.867 -28.8838L110.84 77.2918L56.5107 22.8925L5.03267 -28.7234C18.0084 -29.3829 31.1942 -28.9359 44.1901 -28.9493L110.867 -28.8838Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.323 355.681L219.074 357.924C216.205 360.008 205.005 371.501 201.81 374.694L165.519 411.131C151.289 411.904 130.429 411.434 116.104 411.098L170.409 356.664C152.467 338.979 134.659 321.157 116.984 303.201C133.374 302.957 149.765 302.911 166.155 303.06C179.423 316.361 206.31 344.851 219.323 355.681Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.459 685.46C201.351 707.48 182.577 729.475 167.5 743.061C151.832 729.643 140.728 715.218 136.559 694.861C136.386 691.82 136.379 688.778 136.538 685.737C137.67 665.657 153.197 647.787 167.463 635.101C183.026 649.14 195.8 663.935 198.459 685.46Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.96 685.569C186.888 695.189 180.692 704.556 171.09 706.548C161.488 708.53 152.083 702.389 150.04 692.794C147.978 683.124 154.181 673.613 163.866 671.614C173.55 669.606 183.015 675.873 184.96 685.569Z",
    fill: "url(#paint17_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.383 684.451C184.066 689.887 182.662 695.802 178.719 699.902C174.775 704.001 168.915 705.631 163.422 704.161C157.929 702.691 153.672 698.339 152.308 692.819C150.282 684.619 155.145 676.293 163.283 674.025C171.422 671.765 179.885 676.377 182.383 684.451Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.748 635.134C161.149 637.697 158.596 640.301 156.09 642.956C144.026 655.928 133.373 672.664 134.167 691.063C135.068 711.924 149.308 729.45 164.006 742.943L141.445 743.237L113.68 743.246L113.641 634.882C130.243 634.563 147.166 634.294 163.748 635.134Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.348 98.9678C518.249 110.927 531.886 112.04 529.065 118.559C524.198 125.23 523.423 127.873 528.967 134.39C531.806 137.728 521.331 143.456 526.319 149.076C526.836 149.659 529.094 152.991 529.794 153.929C526.221 164.662 520.911 156.863 529.453 172.311C529.558 179.432 520.602 177.105 528.719 189.976C521.081 190.107 495.49 192.729 494.64 182.506C495.966 178.874 500.118 175.325 502.975 172.511C499.863 170.724 498.664 169.948 495.924 167.642C493.576 156.163 500.705 157.405 502.529 154.625C494.035 146.756 491.619 143.791 502.046 136.15C502.234 132.367 493.458 134.007 495.546 123.956C497.287 120.899 499.877 119.619 502.836 117.751C502.757 115.4 498.437 114.979 496.719 112.625C491.384 105.314 498.906 102.408 502.943 98.8493C499.423 95.7189 496.261 93.3227 494.462 89.0018C494.77 79.0938 519.786 81.5891 526.872 81.7445C529.412 83.7626 520.49 88.2717 530.348 98.9678Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.791 98.9206C488.225 110.762 495.616 107.583 496.783 118.563C496.682 117.612 493.024 125.376 492.953 127.17C492.793 131.275 497.936 135.113 497.444 136.084C495.947 139.036 491.18 143.164 493.402 147.572C501.33 157.707 494.322 153.536 492.92 162.517C492.638 164.323 494.177 167.689 495.638 169.242C499.117 172.938 495.239 175.519 493.103 179.816C492.94 183.165 494.232 186.031 495.365 189.182L494.884 189.644C482.89 190.707 446.363 193.112 470.809 173.011L470.364 171.554C465.872 169.006 465.712 170.154 462.721 165.439C463.694 158.329 464.271 157.86 470.724 154.936C460.709 146.103 459.614 142.723 471.351 135.791C469.307 134.501 464.952 132.707 464.003 130.806C460.321 123.437 465.691 120.859 470.629 118.05C471.382 114.392 460.86 115.974 463.386 105.091C465.12 102.316 468.45 100.634 471.284 98.8685C460.676 93.6099 458.967 84.6951 472.053 81.6907C474.294 81.1765 494.163 81.5268 495.388 82.4544C492.204 90.4485 491.833 92.0481 497.791 98.9206Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.101 356.438C165.578 360.42 120.638 403.579 113.93 410.258C113.32 393.026 113.683 375.66 113.663 358.412L113.683 303.26C131.864 320.538 149.331 338.727 167.101 356.438Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.361 84.5274C443.263 88.2888 442.254 127.43 442.281 134.715C425.554 134.912 408.826 134.876 392.1 134.607L392.109 133.475L390.975 131.73L390.23 132.324C388.58 128.036 389.409 89.197 389.444 81.7213L438.871 81.6709L439.816 82.6556L441.361 84.5274Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.816 82.6556C425.581 96.9702 403.738 117.422 390.976 131.73L390.231 132.324C388.58 128.036 389.409 89.197 389.444 81.7213L438.872 81.6709L439.816 82.6556Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.361 84.5281C430.44 95.2964 419.602 106.148 408.847 117.082C405.913 120.042 394.979 131.353 392.109 133.476L390.975 131.731C403.738 117.423 425.58 96.9708 439.816 82.6562L441.361 84.5281Z",
    fill: "url(#paint18_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.744 299.658C407.136 301.567 342.865 300.751 334.161 300.744L334.125 248.076C338.062 246.8 366.321 247.364 372.446 247.434C372.688 254.661 374.219 261.786 376.966 268.475C383.384 283.836 394.608 293.46 409.744 299.658Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.805 192.668C408.729 194.087 403.553 195.967 401.739 196.99C382.92 207.605 373.78 224.811 372.469 245.408L334.163 245.459L334.151 192.472C357.834 192.178 386.349 191.837 409.805 192.668Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.106 81.7495L553.078 189.98C545.189 190.172 533.923 191.145 527.568 186.265C524.756 181.001 531.539 176.397 535.156 173.15C535.238 171.917 535.623 172.304 533.828 171.559C529.796 169.885 529.109 168.202 526.973 164.57C530.444 153.044 533.505 158.222 535.873 154.157C534.571 153.449 529.612 150.859 529.01 149.826C524.067 141.35 530.89 139.418 535.74 135.909C533.422 134.374 529.816 132.394 528.357 130.243C527.332 128.756 527 126.899 527.446 125.149C528.39 121.552 532.478 119.445 535.503 117.593C534.995 114.835 516.617 110.975 535.433 99.1584C534.658 96.8858 528.175 95.4323 526.762 88.2078C529.044 79.8121 546.08 81.5983 553.106 81.7495Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.922 303.066C110.503 330.773 111.112 358.495 110.66 386.212C103.862 365.51 95.5658 349.195 80.4155 333.232C64.5924 318.146 48.0647 309.985 27.4953 303.367C55.198 302.32 83.1981 302.752 110.922 303.066Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.594 438.084C111.674 465.893 110.877 493.98 110.87 521.822C83.3914 522.066 55.5047 522.797 28.0648 521.562C33.1076 518.26 47.3416 515.076 55.1082 510.682C83.7046 494.484 101.93 469.607 110.594 438.084Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.889 81.7353C449.016 81.6764 460.859 81.1404 462.994 82.052C462.423 86.2217 457.603 88.0272 462.869 94.4981C464.22 96.1582 465.142 97.0463 465.075 99.1853C463.292 101.581 459.248 106.477 460.569 108.7C468.484 121.988 462.67 115.059 460.595 127.178C460.112 129.992 467.066 134.759 464.272 137.377C453.696 147.284 469.151 150.83 463.248 157.115C454.418 166.518 468.8 169.065 463.292 176.711C459.054 181.687 460.939 185.25 464.095 189.988L444.941 189.973L444.936 118.348C444.932 109.773 445.471 90.8375 444.766 83.019L445.889 81.7353Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.084 25.873L553.08 79.4339L501.421 79.4154C500.992 78.9365 501.104 78.855 500.934 78.1039C517.328 60.7253 536.038 42.8047 553.084 25.873Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7129 634.924C52.2449 640.78 10.7987 681.486 3.01274 687.753C2.35677 670.253 2.91113 652.526 2.90022 635C20.4031 634.328 38.194 634.58 55.7129 634.924Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.994 303.325C381.636 310.337 340.327 351.388 334.267 355.79C333.739 339.012 334.15 320.072 334.152 303.139C344.574 302.693 377.481 302.402 386.994 303.325Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.037 410.702C382.392 412.106 341.341 411.291 334.182 411.148L334.145 359.923L334.657 359.302C337.06 359.898 381.474 405.132 387.037 410.702Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.103 -28.8758L553.049 24.5884L525.672 -2.73763L499.846 -28.6951C517.597 -28.964 535.35 -29.0245 553.103 -28.8758Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.171 358.21C442.766 374.744 442.269 394.429 442.279 411.199C426.145 411.669 406.869 411.568 390.73 411.19C391.306 407.855 436.11 364.251 442.171 358.21Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.748 690.231C111.775 707.69 110.892 725.72 110.914 743.237C93.6413 743.355 76.3677 743.313 59.0949 743.119C59.2789 740.439 105.93 695.02 110.748 690.231Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.863 635.042L110.836 687.913C101.892 679.671 93.4654 670.648 84.8437 662.061C75.771 653.046 66.7671 643.964 57.8322 634.815C75.4787 634.781 93.231 634.395 110.863 635.042Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.914 79.2281C484.158 80.1606 461.248 79.4768 446.689 79.5717L444.936 78.7198L444.907 26.2461L497.914 79.2281Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.315 -28.6271C494.561 -25.0673 481.925 -12.5842 477.877 -8.64559C467.471 1.47913 455.691 14.5478 444.942 23.8029L444.918 -28.8934C462.384 -29.0564 479.852 -28.9682 497.315 -28.6271Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.23 303.093C442.438 320.689 442.241 338.701 442.241 356.328C433.839 347.388 423.984 337.928 415.246 329.167L389.435 303.166C404.172 302.288 426.987 303.05 442.23 303.093Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.979 133.906L384.271 134.732C367.681 134.925 350.781 134.774 334.164 134.787L334.173 83.1025L384.979 133.906Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.531 136.954C382.801 140.586 340.194 183.006 334.212 188.256L334.138 137.026L384.531 136.954Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.824 189.914L389.467 190.028L389.418 140.51L390.406 139.657C407.221 156.008 424.051 173.981 440.824 189.914Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.738 -28.8604C206.015 -14.1005 184.444 7.21175 169.745 21.0155L168.998 22.1044C168.07 17.8305 168.568 -22.229 168.591 -28.7134C184.43 -29.3914 203.733 -28.9394 219.738 -28.8604Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.317 29.126L166.438 79.4884L115.147 79.2414L148.199 46.1694C151.784 42.5887 162.278 32.4925 164.917 29.0723L166.317 29.126Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.191 28.7051C185.633 45.1234 203.405 63.6371 220.199 79.4842L168.579 79.4825C168.579 64.6638 169.232 43.817 168.491 29.4906L169.191 28.7051Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.314 -28.8479C166.719 -11.7835 166.343 5.3826 166.349 22.4579L139.701 -4.12965L115.13 -28.8807C132.191 -28.9924 149.253 -28.9815 166.314 -28.8479Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.592 26.2178L163.569 27.1445C150.466 41.5053 128.035 63.8072 113.743 77.3464L113.627 26.2279L162.592 26.2178Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.157 81.7158C387.189 89.0008 387.986 128.381 386.388 132.51C380.73 126.389 337.766 84.7816 337.302 81.7738L387.157 81.7158Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.787 526.291C111.224 543.254 110.848 560.317 110.856 577.289L60.5468 577.205C63.9879 570.845 103.368 533.676 110.787 526.291Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.142 139.464L387.163 189.998C370.272 189.988 352.775 190.219 335.936 189.945L386.234 139.623L387.142 139.464Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.278 137.006C442.258 153.932 442.454 171.36 442.189 188.243L407.425 153.237C404.697 150.5 394.307 139.783 392.071 138.124L392.208 137.008L442.278 137.006Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.702 -26.9697C130.538 -10.3002 147.239 6.50381 163.806 23.4414L161.944 24.4529C157.346 23.6716 120.625 24.1437 113.674 24.1698L113.702 -26.9697Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.554 152.793C111.395 178.42 111.415 204.049 111.616 229.677C109.174 229.746 106.437 230.005 104.022 229.693C101.774 229.403 100.924 228.43 99.5299 226.764C98.2028 222.476 99.8465 216.192 100.485 211.733C100.984 208.399 102.008 204.58 99.7306 201.681C96.775 197.918 87.4805 198.13 82.9795 197.619L82.8821 184.859C87.7628 183.968 95.8931 184.448 99.5803 180.957C104.835 175.982 98.3515 165.278 98.5691 159.081C98.6354 157.208 99.2603 155.464 100.699 154.209C103.449 151.81 108.146 152.644 111.554 152.793Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.552 657.105C435.895 668.858 430.457 672.807 419.617 673.908C419.79 680.436 421.498 690.198 415.928 694.181C413.594 694.34 413.021 694.483 410.967 693.181C407.193 688.51 408.654 672.026 408.727 665.069C408.787 656.164 407.769 646.897 409.155 638.134C409.947 633.118 414.449 628.749 419.625 630.774C427.12 633.715 426.005 639.394 423.393 645.536C423.285 645.788 425.222 647.552 425.615 647.493C432.079 650.887 432.399 650.409 435.552 657.105Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.815 254.471L175.655 255.13C157.17 250.81 138.734 235.869 127.572 220.712C129.959 219.211 132.728 217.062 135.045 215.365C138.431 211.785 139.547 210.05 142.216 205.928C160.962 220.187 168.866 232.751 176.815 254.471Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.94 126.859C170.557 148.419 159.763 162.931 142.183 176.359C140.435 173.409 138.087 170.569 135.967 167.849C133.54 165.523 130.326 163.578 127.492 161.713C140.677 144.089 155.586 133.078 176.94 126.859Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.32 190.947C194.053 199.238 156.999 206.546 145.227 201.225C144.321 199.198 145.268 193.645 145.536 191.098C145.365 187.647 144.622 184.087 144.007 180.673C166.507 177.572 183.048 180.808 203.32 190.947Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.154 187.331C143.826 194.44 142.273 201.96 138.357 207.972C132.507 216.954 123.912 220.227 113.886 222.241L113.79 208.108C114.602 207.862 115.412 207.606 116.217 207.339C122.99 205.089 125.77 201.713 128.874 195.545C129.229 191.296 129.257 187.188 127.176 183.302C124.327 177.979 119.301 175.985 113.85 174.414L113.784 160.064C119.62 161.259 124.823 162.569 129.852 165.875C137.674 171.016 141.328 178.434 143.154 187.331Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.167 228.432C197.082 229.608 190.136 227.298 184.417 226.908C162.705 225.428 159.115 216.044 143.965 204.562C146.144 203.921 147.983 204.665 150.029 204.48C172.257 202.473 186.637 213.846 203.167 228.432Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.734 272.857C150.31 275.874 150.177 279.394 150.363 282.486C141.202 272.394 129.504 258.384 126.765 244.803C125.928 240.651 126.412 235.562 126.49 231.311C125.868 228.096 125.709 224.698 125.375 221.437C129.103 226.691 133.495 231.103 137.7 235.94C146.901 246.524 147.892 259.473 149.734 272.857Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.331 153.567C192.414 164.266 181.793 170.303 168.704 177.493C159.312 177.024 152.884 177.497 143.73 178.479C161.531 158.188 176.835 154.568 203.331 153.567Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21 100.199C150.431 113.381 148.254 132.407 140.285 143.173C135.801 149.232 130.202 154.492 125.62 160.582C126.11 153.568 125.8 146.398 126.718 139.443C128.673 124.626 140.619 111.014 150.21 100.199Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.049 358.227L414.981 382.28L391.829 359.151L392.095 358.243C407.746 358.084 423.398 358.075 439.049 358.227Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.744 690.164C102.029 698.163 90.4541 707.556 83.6533 714.21L70.8682 701.473L59.6269 690.215C75.2383 689.551 91.1201 689.938 106.744 690.164Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.26 23.2503L493.619 24.5382C489.936 23.8434 454.725 24.1677 448.324 24.0963C456.086 16.0535 464.275 8.02665 472.182 0.0947266L495.26 23.2503Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.046 332.031L439.098 356.076L392.353 356.143L391.888 355.269C399.507 347.607 407.317 339.525 415.046 332.031Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.242 27.216L472.183 50.3816L448.14 26.2582L494.337 26.2305L495.242 27.216Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.374 0.0957031C533.008 7.71845 541.803 16.961 549.649 24.1486C533.945 24.33 518.237 24.3124 502.534 24.0965L502.563 22.627C509.71 16.4737 518.573 6.99927 525.374 0.0957031Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.75 354.336L384.555 356.126C368.982 356.218 353.41 356.185 337.838 356.025C345.866 348.077 353.82 340.062 361.699 331.964C367.627 337.886 378.75 349.724 384.75 354.336Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.978 -1.46644L500.898 21.6396L500.264 21.9571C499.472 7.04351 499.883 -10.5191 499.875 -25.626L523.978 -1.46644Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1436 662.481L59.151 685.417L58.5337 685.686C57.53 681.511 58.0062 645.384 58.049 638.461L82.1436 662.481Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2588 687.997C38.2803 688.114 22.3019 688.106 6.32429 687.997L18.4828 675.865L30.4533 663.96C38.4862 671.874 46.4224 679.889 54.2588 687.997Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.533 330.537L390.95 352.841L390.039 354.059C388.915 350.236 389.413 313.28 389.446 306.437L413.533 330.537Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.143 360.42C387.272 376.181 387.292 391.943 387.205 407.696C379.311 399.823 371.02 391.783 363.283 383.801C370.585 376.517 379.1 368.376 385.955 360.823L387.143 360.42Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.815 28.583C498.735 33.0283 497.714 68.1829 497.732 75.9208L486.203 64.4468L473.748 51.9201C479.398 46.27 492.079 34.2457 496.815 28.583Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.262 306.589L387.16 353.959L385.914 353.539C382.738 349.329 367.789 334.985 363.297 330.519C371.201 322.459 379.19 314.481 387.262 306.589Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8992 638.251L55.916 686.577L43.2342 673.664L31.8803 662.448C39.9359 654.432 47.9427 646.367 55.8992 638.251Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.781 359.336L361.706 382.373C353.938 374.416 346.126 366.502 338.27 358.638C350.252 357.521 371.968 358.042 384.518 358.201L384.781 359.336Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8545 692.66L55.9443 739.801L31.9758 715.798L54.6878 693.063L55.8545 692.66Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8374 692.643C60.6964 693.096 78.8242 712.454 82.0654 715.797L71.0559 726.77L58.086 739.834C58.0826 726.627 58.6932 705.195 57.8374 692.643Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.004 51.7964C516.299 59.4502 507.247 68.0584 500.047 76.0223C499.956 60.4231 499.616 44.0938 500.156 28.5576L500.927 28.7752C508.477 36.4198 516.208 44.4534 524.004 51.7964Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2402 691.298L30.4014 714.176L6.38838 690.189C21.8142 690.005 37.2417 689.963 52.6675 690.072L53.2402 691.298Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.562 383.751L389.499 407.779C389.454 401.486 388.819 364.124 390.022 360.26L390.93 361.486L413.562 383.751Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.733 -25.4482C497.712 -16.6972 498.492 15.6842 497.187 22.0576L496.385 21.3443C489.349 13.8224 481.104 5.89043 473.775 -1.45927L497.733 -25.4482Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.629 688.038C92.5097 688.072 75.5275 688.492 60.5528 687.837L60.5813 686.98C68.3522 679.393 75.9013 671.512 83.6091 664.01L107.629 688.038Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.551 26.3118C518.177 26.2009 533.803 26.1858 549.43 26.2681L525.368 50.3638C517.826 42.668 510.219 35.036 502.547 27.4687L502.551 26.3118Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64 225.151C124.969 240.767 123.834 253.854 118.66 268.666C117.569 271.789 116.644 275.286 114.596 277.93L113.87 276.706L113.794 224.112C116.733 223.534 119.543 222.871 122.555 223.22L123.64 225.151Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.746 133.957C124.561 142.813 124.311 150.98 123.148 159.792C120.074 159.15 116.929 158.764 113.823 158.297L113.819 130.098L113.924 101.73C118.49 112.27 121.988 122.578 123.746 133.957Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.481 563.083C379.367 565.351 345.208 581.885 340.378 584.305C337.575 584.607 335.944 583.498 333.378 582.238C334.963 578.231 368.724 562.444 374.644 559.856C377.788 560.251 377.581 560.823 380.481 563.083Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.042 569.316C385.822 571.903 355.649 586.388 350.687 588.917L342.613 585.732C350.425 581.221 374.335 568.988 382.201 565.955C385.448 566.468 385.107 566.93 388.042 569.316Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.456 186.45C126.743 188.535 127.008 190.928 126.741 193.015C126.279 196.616 123.095 201.388 120.202 203.506C118.324 204.879 117.266 204.834 115.048 204.453C113.506 202.159 113.87 200.416 113.834 197.732C113.686 192.227 112.659 184.626 114.89 179.547C115.602 177.928 115.972 177.887 117.591 177.237C121.503 178.399 124.401 183.126 126.456 186.45Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.17 696.264C410.229 700.893 410.001 709.354 403.864 709.446C397.34 705.573 398.476 696.104 398.674 689.644C398.563 685.376 398.081 679.78 403.554 678.646C409.483 682.914 404.053 687.921 410.17 696.264Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.09 556.916C371.663 559.613 340.339 574.509 335.334 576.752L333.805 576.08C333.928 573.568 334.058 572.887 334.672 570.476C338.779 567.334 362.032 556.05 367.168 553.815C369.953 554.059 370.531 555.093 373.09 556.916Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.588 575.366C393.495 577.794 366.658 590.699 362.122 592.992C359.678 592.27 356.02 590.774 353.526 589.858C364.539 584.599 378.678 576.155 389.609 571.988C392.391 572.299 393.132 573.492 395.588 575.366Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.095 581.675C400.523 584.12 378.189 594.689 373.422 597.159C370.653 596.285 367.778 595.638 365.651 593.697C375.48 588.262 387.742 582.507 397.929 577.398L403.095 581.675Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.106 551.58C362.159 553.958 337.073 567.064 334.54 566.568L332.839 563.46C335.252 558.461 354.202 549.841 360.01 547.64C362.986 548.261 363.609 549.454 366.106 551.58Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.658 587.749C408.617 589.396 388.349 599.436 384.615 601.326C382.167 600.603 378.567 599.125 376.076 598.192C384.294 593.958 396.292 587.371 404.564 584.128C407.529 584.573 408.107 585.699 410.658 587.749Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.157 593.773C414.063 596.604 400.926 602.838 395.858 605.367C393.443 604.729 389.61 603.25 387.131 602.376C395.323 598.52 403.462 592.706 412.12 590.622C414.301 590.093 416.318 592.328 418.157 593.773Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.493 545.237C356.227 547.598 337.578 556.714 334.557 556.764L333.144 555.05C333.563 553.404 333.89 552.631 334.545 551.051C339.791 547.052 345.871 543.196 352.602 542.07C354.966 541.667 356.445 543.591 358.493 545.237Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.998 599.528C423.654 601.998 410.106 608.056 406.805 609.677L398.495 606.569C404.438 603.435 413.232 598.049 419.577 596.562C421.701 596.058 423.203 598.016 424.998 599.528Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.161 606.115C429.049 608.543 422.693 611.576 418.303 613.853C415.389 612.886 412.867 612.181 410.257 610.5L427.526 601.679C428.891 602.552 431.763 604.997 433.161 606.115Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.011 539.179C349.566 540.935 337.82 546.648 334.774 547.253L333.369 545.833C333.63 544.447 334.045 543.069 334.417 541.708C340.319 535.676 344.282 533.66 351.011 539.179Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.088 611.71C439.134 613.534 431.803 616.802 429.46 617.978L421.033 614.836C425.23 612.752 429.486 609.45 434.002 608.602C436.566 608.123 437.923 609.98 440.088 611.71Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.677 617.995C441.744 623.355 438.758 621.667 432.127 618.953C439.636 614.803 440.759 612.265 447.677 617.995Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.1 134.607L393.117 135.904L392.208 137.007L392.072 138.124L390.406 139.657L389.417 140.51L387.142 139.464L386.234 139.623C385.666 138.652 385.25 137.818 384.532 136.954L384.272 134.732L384.979 133.906L386.388 132.51L390.23 132.324L390.975 131.73L392.109 133.475L392.1 134.607Z",
    fill: "url(#paint19_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.516 533.113C341.73 535.003 337.285 537.347 334.594 537.255L333.266 535.734C333.835 532.239 334.151 531.072 337.328 529.425C340.242 529.601 341.339 531.071 343.516 533.113Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.354 356.144L392.096 358.244L391.829 359.151L390.931 361.487L390.023 360.26L387.144 360.42L385.955 360.823L384.781 359.336L384.517 358.202L384.555 356.127L384.75 354.337L385.914 353.539L387.16 353.959L390.04 354.06L390.95 352.842L391.888 355.27L392.354 356.144Z",
    fill: "url(#paint20_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.563 22.6276L502.534 24.0971L502.552 26.3125L502.548 27.4695L500.928 28.7768L500.157 28.5591C498.49 28.1164 498.339 27.9761 496.815 28.5835L495.243 27.2174L494.337 26.2319L493.619 24.539L495.26 23.251L496.385 21.3447L497.187 22.058C498.257 22.5377 499.08 22.2008 500.264 21.958L500.898 21.6405L502.563 22.6276Z",
    fill: "url(#paint21_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5811 686.98L60.5525 687.837C59.4875 689.626 59.2674 691.306 57.837 692.642L55.854 692.659L54.6874 693.062L53.2394 691.298L52.6666 690.071L54.2582 687.996L54.7915 686.627L58.5334 685.686L59.1507 685.417L60.5811 686.98Z",
    fill: "url(#paint22_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.189 624.019L453.023 625.649C449.869 626.204 446.591 624.423 443.542 623.171C445.714 621.927 446.832 621.432 449.16 620.499C451.773 620.482 453.202 622.238 455.189 624.019Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.936 78.7198L446.688 79.5717L445.889 81.7351L444.766 83.0189L441.361 84.5278L439.815 82.656L438.871 81.6713L438.858 79.4096L440.101 78.9055L440.82 78.0485C443.343 77.3915 442.26 77.3 444.936 78.7198Z",
    fill: "url(#paint23_linear_388_674)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_388_674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.178 -363L222.158 1077.27L776.362 1077.28C776.503 1019.72 777.311 959.451 776.386 902.085C776.832 885.937 776.522 868.328 776.505 852.079C776.59 837.124 776.546 822.178 776.373 807.223C777.037 788.933 776.424 766.551 776.428 747.765L776.44 630.177C777.406 592.042 776.946 545.825 776.377 507.539C777.694 452.551 776.434 391.766 776.435 336.376L776.374 11.0067C776.571 -1.84015 776.597 -14.6887 776.454 -27.5355L776.43 -362.987L222.178 -363Z",
    fill: "url(#paint24_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.049 524.343L224.069 743.178C272.056 744.262 320.784 742.557 368.857 743.246C392.377 743.59 417.017 743.725 440.488 742.968C420.669 726.644 400.742 710.446 380.709 694.382C380.662 700.104 380.98 710.656 372.662 711.076C370.758 711.168 368.905 710.446 367.557 709.102C365.948 707.489 365.287 705.707 365.358 703.473C365.337 694.836 364.055 699.549 358.404 694.046C354.077 689.837 355.195 682.023 355.387 676.016C344.559 673.588 341.746 671.538 339.127 660.364L306.529 633.672C351.157 598.344 396.502 560.461 440.646 524.36C369.395 523.469 295.384 524.124 224.049 524.343Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.503 628.127C241.014 645.518 247.317 645.905 260.509 637.68C260.554 640.393 260.325 644.468 261.731 646.569C263.095 643.309 262.728 638.688 262.71 635.042L286.777 634.991L288.647 634.185L288.071 633.311C282.565 632.429 268.905 632.731 262.685 632.731C262.738 629.211 263.082 623.842 261.645 620.742C260.334 622.859 260.555 627.304 260.472 629.984C254.072 625.539 248.515 620.91 242.503 628.127Z",
    fill: "url(#paint25_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.316 629.513C244.185 632.815 243.767 635.738 245.256 638.687C250.128 643.039 254.184 639.074 258.765 635.94L259.848 634.327C258.529 629.286 249.365 623.472 244.316 629.513Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.052 303.081L224.078 521.847L332.229 521.839L332.232 303.12C296.173 302.849 260.111 302.835 224.052 303.081Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.938 633.983C312.574 636.445 335.305 654.365 339.249 657.524C343.026 647.4 344.806 651.097 350.098 643.872C350.217 641.007 348.733 634.529 351.46 632.437C376.799 613.013 369.819 662.288 370.673 675.092C380.614 678.99 380.568 681.393 380.577 691.172C399.464 707.539 423.288 726.333 442.98 741.985L443.016 723.88L442.996 585.086C399.517 601.746 354.683 617.785 310.938 633.983Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.474 245.455C401.257 229.36 396.16 216.044 383.566 205.305C372.46 195.886 358.031 191.336 343.532 192.682C329.066 193.958 315.714 200.985 306.469 212.188C297.409 223.097 293.075 237.17 294.428 251.287C295.776 265.83 302.886 279.229 314.174 288.495C325.344 297.64 339.718 301.913 354.068 300.354C368.342 298.903 381.431 291.767 390.387 280.555C398.26 270.758 401.816 259.992 402.514 247.581C395.972 247.419 381.316 246.326 375.836 248.816L373.816 247.626L374.145 245.542C370.819 241.703 351.754 223.328 351.109 220.956L352.093 220.554C357.822 225.011 371.767 239.661 377.534 245.426L402.474 245.455Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.145 245.541C369.21 245.451 335.822 244.735 333.252 246.155L333.5 247.087C339.661 248.029 366.163 247.601 373.816 247.626L374.145 245.541Z",
    fill: "url(#paint26_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.817 247.626C366.823 256.05 357.427 263.753 350.764 271.781L351.163 272.23C356.001 269.544 373.147 253.182 375.837 248.816L373.817 247.626Z",
    fill: "url(#paint27_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.051 192.488L224.076 300.701C259.327 300.738 295.819 301.206 330.963 300.517C320.681 296.344 315.59 293.012 307.616 285.513C302.562 280.096 298.571 273.775 295.851 266.883C290.457 252.868 290.839 237.286 296.914 223.552C303.963 207.794 315.468 198.739 331.191 192.677C298.579 191.28 257.344 192.329 224.051 192.488Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.133 214.474C244.595 224.352 250.03 223.525 252.549 229.231C250.807 231.356 249.143 233.544 247.562 235.791C245.492 238.739 244.889 239.911 245.499 243.328L246.783 243.013L247.107 240.956C250.443 232.75 254.107 231.834 261.97 229.319C245.159 224.424 253.008 221.54 245.133 214.474Z",
    fill: "url(#paint28_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.94 260.693C261.585 265.612 264.078 267.667 267.148 271.478C264.657 274.479 261.481 277.159 262.535 281.658L263.628 281.36L264.102 279.329C265.867 276.072 267.825 274.364 271.182 272.772L271.765 272.501L271.177 271.362L272.077 271.804C268.583 269.074 264.743 266.547 263.753 262.227C263.627 261.672 262.57 261.135 261.94 260.693Z",
    fill: "url(#paint29_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.995 -27.7637L370.178 45.0813C363.642 51.6219 341.665 72.6964 337.057 78.906L338.3 79.4101C370.061 80.5796 410.654 79.6369 442.971 79.3874C443.355 43.8983 443.004 7.7758 442.995 -27.7637Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.139 520.739C340.43 523.377 430.947 521.865 442.972 521.848L443.022 416.904L442.399 416.03C439.257 417.425 348.294 509.59 337.139 520.739Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.907 -28.9156L334.98 77.5012C352.57 59.4378 370.976 41.3996 388.824 23.5329C406.237 6.19119 423.556 -11.2446 440.78 -28.7736C407.886 -29.9734 368.303 -29.0189 334.907 -28.9156Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.872 413.601L334.959 519.89L387.49 467.329L441.002 413.643C406.277 413.005 369.741 413.551 334.872 413.601Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.811 98.9678C258.909 110.927 245.273 112.04 248.093 118.559C252.96 125.23 253.735 127.873 248.191 134.39C245.352 137.728 255.827 143.456 250.84 149.076C250.322 149.659 248.065 152.991 247.364 153.929C250.937 164.662 256.247 156.863 247.705 172.311C247.6 179.432 256.556 177.105 248.439 189.976C256.077 190.107 281.668 192.729 282.518 182.506C281.192 178.874 277.041 175.325 274.183 172.511C277.295 170.724 278.494 169.948 281.234 167.642C283.582 156.163 276.453 157.405 274.629 154.625C283.123 146.756 285.539 143.791 275.112 136.15C274.924 132.367 283.7 134.007 281.612 123.956C279.871 120.899 277.282 119.619 274.322 117.751C274.401 115.4 278.721 114.979 280.439 112.625C285.774 105.314 278.253 102.408 274.215 98.8493C277.735 95.7189 280.897 93.3227 282.697 89.0018C282.388 79.0938 257.372 81.5891 250.286 81.7445C247.746 83.7626 256.669 88.2717 246.811 98.9678Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.367 98.9206C288.933 110.762 281.542 107.583 280.375 118.563C280.476 117.612 284.135 125.376 284.205 127.17C284.365 131.275 279.222 135.113 279.714 136.084C281.211 139.036 285.978 143.164 283.757 147.572C275.829 157.707 282.836 153.536 284.239 162.517C284.52 164.323 282.981 167.689 281.52 169.242C278.041 172.938 281.919 175.519 284.055 179.816C284.219 183.165 282.926 186.031 281.793 189.182L282.274 189.644C294.268 190.707 330.795 193.112 306.349 173.011L306.794 171.554C311.286 169.006 311.446 170.154 314.437 165.439C313.464 158.329 312.887 157.86 306.434 154.936C316.449 146.103 317.544 142.723 305.808 135.791C307.851 134.501 312.206 132.707 313.155 130.806C316.837 123.437 311.467 120.859 306.529 118.05C305.776 114.392 316.298 115.974 313.772 105.091C312.038 102.316 308.709 100.634 305.874 98.8685C316.482 93.6099 318.191 84.6951 305.105 81.6907C302.865 81.1765 282.995 81.5268 281.77 82.4544C284.954 90.4485 285.326 92.0481 279.367 98.9206Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.797 84.5274C333.895 88.2888 334.904 127.43 334.877 134.715C351.604 134.912 368.333 134.876 385.059 134.607L385.049 133.475L386.183 131.73L386.928 132.324C388.579 128.036 387.75 89.197 387.714 81.7213L338.287 81.6709L337.342 82.6556L335.797 84.5274Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.342 82.6556C351.577 96.9702 373.42 117.422 386.183 131.73L386.928 132.324C388.578 128.036 387.749 89.197 387.714 81.7213L338.287 81.6709L337.342 82.6556Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.797 84.5281C346.718 95.2964 357.556 106.148 368.311 117.082C371.245 120.042 382.179 131.353 385.049 133.476L386.183 131.731C373.421 117.423 351.578 96.9708 337.342 82.6562L335.797 84.5281Z",
    fill: "url(#paint30_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.414 299.658C370.022 301.567 434.293 300.751 442.997 300.744L443.033 248.076C439.096 246.8 410.837 247.364 404.712 247.434C404.47 254.661 402.939 261.786 400.192 268.475C393.774 283.836 382.55 293.46 367.414 299.658Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.354 192.668C368.429 194.087 373.605 195.967 375.419 196.99C394.238 207.605 403.378 224.811 404.689 245.408L442.995 245.459L443.008 192.472C419.325 192.178 390.809 191.837 367.354 192.668Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.052 81.7495L224.08 189.98C231.969 190.172 243.235 191.145 249.59 186.265C252.402 181.001 245.619 176.397 242.002 173.15C241.92 171.917 241.535 172.304 243.33 171.559C247.362 169.885 248.05 168.202 250.185 164.57C246.714 153.044 243.653 158.222 241.285 154.157C242.587 153.449 247.546 150.859 248.148 149.826C253.092 141.35 246.268 139.418 241.418 135.909C243.736 134.374 247.342 132.394 248.801 130.243C249.826 128.756 250.158 126.899 249.712 125.149C248.768 121.552 244.68 119.445 241.655 117.593C242.163 114.835 260.541 110.975 241.725 99.1584C242.5 96.8858 248.983 95.4323 250.396 88.2078C248.114 79.8121 231.078 81.5983 224.052 81.7495Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.269 81.7353C328.142 81.6764 316.299 81.1404 314.164 82.052C314.735 86.2217 319.555 88.0272 314.289 94.4981C312.938 96.1582 312.016 97.0463 312.084 99.1853C313.867 101.581 317.91 106.477 316.589 108.7C308.674 121.988 314.488 115.059 316.564 127.178C317.046 129.992 310.092 134.759 312.886 137.377C323.463 147.284 308.007 150.83 313.91 157.115C322.74 166.518 308.359 169.065 313.867 176.711C318.104 181.687 316.219 185.25 313.063 189.988L332.217 189.973L332.222 118.348C332.226 109.773 331.687 90.8375 332.392 83.019L331.269 81.7353Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.074 25.873L224.078 79.4339L275.738 79.4154C276.166 78.9365 276.054 78.855 276.224 78.1039C259.831 60.7253 241.12 42.8047 224.074 25.873Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.164 303.325C395.523 310.337 436.831 351.388 442.891 355.79C443.419 339.012 443.008 320.072 443.006 303.139C432.585 302.693 399.677 302.402 390.164 303.325Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.121 410.702C394.766 412.106 435.817 411.291 442.977 411.148L443.014 359.923L442.501 359.302C440.098 359.898 395.684 405.132 390.121 410.702Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.056 -28.8758L224.11 24.5884L251.486 -2.73763L277.312 -28.6951C259.561 -28.964 241.808 -29.0245 224.056 -28.8758Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.987 358.21C334.392 374.744 334.89 394.429 334.88 411.199C351.013 411.669 370.289 411.568 386.428 411.19C385.852 407.855 341.048 364.251 334.987 358.21Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.244 79.2281C293 80.1606 315.91 79.4768 330.469 79.5717L332.222 78.7198L332.251 26.2461L279.244 79.2281Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.843 -28.6271C282.597 -25.0673 295.233 -12.5842 299.281 -8.64559C309.687 1.47913 321.467 14.5478 332.216 23.8029L332.241 -28.8934C314.774 -29.0564 297.306 -28.9682 279.843 -28.6271Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.929 303.093C334.72 320.689 334.918 338.701 334.917 356.328C343.319 347.388 353.174 337.928 361.912 329.167L387.723 303.166C372.987 302.288 350.171 303.05 334.929 303.093Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.18 133.906L392.887 134.732C409.478 134.925 426.377 134.774 442.994 134.787L442.985 83.1025L392.18 133.906Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.627 136.954C394.357 140.586 436.964 183.006 442.946 188.256L443.02 137.026L392.627 136.954Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.334 189.914L387.691 190.028L387.741 140.51L386.752 139.657C369.937 156.008 353.107 173.981 336.334 189.914Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.001 81.7158C389.969 89.0008 389.172 128.381 390.77 132.51C396.428 126.389 439.392 84.7816 439.857 81.7738L390.001 81.7158Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.016 139.464L389.995 189.998C406.887 189.988 424.383 190.219 441.222 189.945L390.924 139.623L390.016 139.464Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.88 137.006C334.9 153.932 334.704 171.36 334.969 188.243L369.733 153.237C372.461 150.5 382.851 139.783 385.087 138.124L384.95 137.008L334.88 137.006Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.606 657.105C341.263 668.858 346.701 672.807 357.542 673.908C357.368 680.436 355.66 690.198 361.231 694.181C363.564 694.34 364.137 694.483 366.191 693.181C369.966 688.51 368.504 672.026 368.431 665.069C368.371 656.164 369.389 646.897 368.004 638.134C367.212 633.118 362.71 628.749 357.533 630.774C350.038 633.715 351.153 639.394 353.765 645.536C353.873 645.788 351.936 647.552 351.543 647.493C345.079 650.887 344.759 650.409 341.606 657.105Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.109 358.227L362.177 382.28L385.329 359.151L385.063 358.243C369.412 358.084 353.76 358.075 338.109 358.227Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.898 23.2503L283.539 24.5382C287.222 23.8434 322.433 24.1677 328.834 24.0963C321.072 16.0535 312.884 8.02665 304.976 0.0947266L281.898 23.2503Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.112 332.031L338.061 356.076L384.805 356.143L385.27 355.269C377.651 347.607 369.841 339.525 362.112 332.031Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.916 27.216L304.975 50.3816L329.018 26.2582L282.821 26.2305L281.916 27.216Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.784 0.0957031C244.15 7.71845 235.355 16.961 227.509 24.1486C243.214 24.33 258.921 24.3124 274.625 24.0965L274.595 22.627C267.448 16.4737 258.586 6.99927 251.784 0.0957031Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.408 354.336L392.603 356.126C408.176 356.218 423.749 356.185 439.321 356.025C431.292 348.077 423.338 340.062 415.46 331.964C409.531 337.886 398.409 349.724 392.408 354.336Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.181 -1.46644L276.261 21.6396L276.895 21.9571C277.686 7.04351 277.275 -10.5191 277.284 -25.626L253.181 -1.46644Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.625 330.537L386.209 352.841L387.119 354.059C388.244 350.236 387.745 313.28 387.712 306.437L363.625 330.537Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.015 360.42C389.887 376.181 389.866 391.943 389.953 407.696C397.847 399.823 406.138 391.783 413.875 383.801C406.573 376.517 398.058 368.376 391.204 360.823L390.015 360.42Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.343 28.583C278.423 33.0283 279.444 68.1829 279.426 75.9208L290.955 64.4468L303.411 51.9201C297.76 46.27 285.08 34.2457 280.343 28.583Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.896 306.589L389.998 353.959L391.245 353.539C394.42 349.329 409.369 334.985 413.862 330.519C405.957 322.459 397.968 314.481 389.896 306.589Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.377 359.336L415.452 382.373C423.22 374.416 431.032 366.502 438.888 358.638C426.907 357.521 405.19 358.042 392.641 358.201L392.377 359.336Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.154 51.7964C260.859 59.4502 269.911 68.0584 277.111 76.0223C277.203 60.4231 277.542 44.0938 277.002 28.5576L276.231 28.7752C268.681 36.4198 260.95 44.4534 253.154 51.7964Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.596 383.751L387.659 407.779C387.704 401.486 388.339 364.124 387.136 360.26L386.228 361.486L363.596 383.751Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.425 -25.4482C279.446 -16.6972 278.666 15.6842 279.971 22.0576L280.773 21.3443C287.809 13.8224 296.054 5.89043 303.383 -1.45927L279.425 -25.4482Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.607 26.3118C258.981 26.2009 243.355 26.1858 227.729 26.2681L251.79 50.3638C259.332 42.668 266.94 35.036 274.611 27.4687L274.607 26.3118Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.677 563.083C397.791 565.351 431.95 581.885 436.78 584.305C439.583 584.607 441.215 583.498 443.78 582.238C442.196 578.231 408.434 562.444 402.514 559.856C399.37 560.251 399.577 560.823 396.677 563.083Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.116 569.316C391.336 571.903 421.509 586.388 426.471 588.917L434.545 585.732C426.733 581.221 402.823 568.988 394.957 565.955C391.71 566.468 392.051 566.93 389.116 569.316Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.988 696.264C366.929 700.893 367.157 709.354 373.295 709.446C379.818 705.573 378.683 696.104 378.484 689.644C378.595 685.376 379.077 679.78 373.604 678.646C367.676 682.914 373.106 687.921 366.988 696.264Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.068 556.916C405.495 559.613 436.819 574.509 441.824 576.752L443.353 576.08C443.23 573.568 443.1 572.887 442.486 570.476C438.38 567.334 415.126 556.05 409.991 553.815C407.205 554.059 406.627 555.093 404.068 556.916Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.57 575.366C383.663 577.794 410.5 590.699 415.037 592.992C417.481 592.27 421.138 590.774 423.632 589.858C412.619 584.599 398.48 576.155 387.549 571.988C384.767 572.299 384.026 573.492 381.57 575.366Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.063 581.675C376.635 584.12 398.969 594.689 403.736 597.159C406.505 596.285 409.38 595.638 411.508 593.697C401.678 588.262 389.416 582.507 379.229 577.398L374.063 581.675Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.052 551.58C414.999 553.958 440.085 567.064 442.618 566.568L444.319 563.46C441.907 558.461 422.956 549.841 417.149 547.64C414.172 548.261 413.55 549.454 411.052 551.58Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.5 587.749C368.541 589.396 388.809 599.436 392.543 601.326C394.991 600.603 398.591 599.125 401.082 598.192C392.864 593.958 380.867 587.371 372.594 584.128C369.63 584.573 369.051 585.699 366.5 587.749Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.001 593.773C363.096 596.604 376.232 602.838 381.3 605.367C383.715 604.729 387.548 603.25 390.027 602.376C381.835 598.52 373.696 592.706 365.038 590.622C362.857 590.093 360.84 592.328 359.001 593.773Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.665 545.237C420.931 547.598 439.58 556.714 442.601 556.764L444.014 555.05C443.595 553.404 443.269 552.631 442.613 551.051C437.367 547.052 431.287 543.196 424.556 542.07C422.192 541.667 420.714 543.591 418.665 545.237Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.16 599.528C353.504 601.998 367.052 608.056 370.353 609.677L378.664 606.569C372.72 603.435 363.926 598.049 357.581 596.562C355.457 596.058 353.955 598.016 352.16 599.528Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.997 606.115C348.109 608.543 354.465 611.576 358.855 613.853C361.77 612.886 364.291 612.181 366.901 610.5L349.632 601.679C348.267 602.552 345.396 604.997 343.997 606.115Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.147 539.179C427.592 540.935 439.338 546.648 442.385 547.253L443.789 545.833C443.529 544.447 443.114 543.069 442.741 541.708C436.84 535.676 432.876 533.66 426.147 539.179Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.07 611.71C338.024 613.534 345.355 616.802 347.699 617.978L356.125 614.836C351.928 612.752 347.672 609.45 343.156 608.602C340.592 608.123 339.235 609.98 337.07 611.71Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.481 617.995C335.414 623.355 338.4 621.667 345.032 618.953C337.522 614.803 336.399 612.265 329.481 617.995Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.058 134.607L384.041 135.904L384.95 137.007L385.087 138.124L386.752 139.657L387.741 140.51L390.016 139.464L390.924 139.623C391.492 138.652 391.908 137.818 392.627 136.954L392.886 134.732L392.179 133.906L390.77 132.51L386.928 132.324L386.183 131.73L385.049 133.475L385.058 134.607Z",
    fill: "url(#paint31_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.643 533.113C435.428 535.003 439.873 537.347 442.564 537.255L443.892 535.734C443.323 532.239 443.008 531.072 439.83 529.425C436.917 529.601 435.82 531.071 433.643 533.113Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.805 356.144L385.063 358.244L385.329 359.151L386.227 361.487L387.135 360.26L390.015 360.42L391.203 360.823L392.377 359.336L392.641 358.202L392.603 356.127L392.408 354.337L391.244 353.539L389.998 353.959L387.119 354.06L386.208 352.842L385.27 355.27L384.805 356.144Z",
    fill: "url(#paint32_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.595 22.6276L274.624 24.0971L274.606 26.3125L274.611 27.4695L276.23 28.7768L277.001 28.5591C278.668 28.1164 278.819 27.9761 280.343 28.5835L281.915 27.2174L282.821 26.2319L283.539 24.539L281.899 23.251L280.773 21.3447L279.971 22.058C278.901 22.5377 278.078 22.2008 276.894 21.958L276.26 21.6405L274.595 22.6276Z",
    fill: "url(#paint33_linear_388_674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.969 624.019L324.135 625.649C327.289 626.204 330.567 624.423 333.617 623.171C331.444 621.927 330.326 621.432 327.998 620.499C325.386 620.482 323.956 622.238 321.969 624.019Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.223 78.7198L330.47 79.5717L331.269 81.7351L332.392 83.0189L335.797 84.5278L337.343 82.656L338.288 81.6713L338.3 79.4096L337.057 78.9055L336.338 78.0485C333.815 77.3915 334.898 77.3 332.223 78.7198Z",
    fill: "url(#paint34_linear_388_674)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_388_674",
    x1: 555,
    y1: 357.142,
    x2: 0.158264,
    y2: 357.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_388_674",
    x1: 52.8301,
    y1: 578.383,
    x2: 3.70964,
    y2: 578.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_388_674",
    x1: 50.4258,
    y1: 466.956,
    x2: 0.157875,
    y2: 466.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_388_674",
    x1: 76.1416,
    y1: 149.732,
    x2: 43.1449,
    y2: 149.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_388_674",
    x1: 55.7637,
    y1: 771.911,
    x2: 0.611019,
    y2: 771.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_388_674",
    x1: 109.756,
    y1: 45.1422,
    x2: 0.614006,
    y2: 45.1422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_388_674",
    x1: 60.9287,
    y1: 578.487,
    x2: 52.1819,
    y2: 578.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_388_674",
    x1: 224.184,
    y1: 498.186,
    x2: 133.979,
    y2: 498.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_388_674",
    x1: 222.961,
    y1: 25.2535,
    x2: 161.943,
    y2: 25.2535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_388_674",
    x1: 224.441,
    y1: -28.672,
    x2: 220.883,
    y2: -28.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_388_674",
    x1: 224.352,
    y1: 133.891,
    x2: 220.6,
    y2: 133.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_388_674",
    x1: 534.869,
    y1: 633.655,
    x2: 488.511,
    y2: 633.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_388_674",
    x1: 76.123,
    y1: 232.689,
    x2: 43.135,
    y2: 232.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_388_674",
    x1: 443.906,
    y1: 246.492,
    x2: 403.013,
    y2: 246.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_388_674",
    x1: 426.395,
    y1: 259.928,
    x2: 401.322,
    y2: 259.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_388_674",
    x1: 532.062,
    y1: 228.901,
    x2: 515.188,
    y2: 228.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_388_674",
    x1: 515.252,
    y1: 271.176,
    x2: 505.081,
    y2: 271.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_388_674",
    x1: 185.312,
    y1: 689.079,
    x2: 149.644,
    y2: 689.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_388_674",
    x1: 441.361,
    y1: 108.066,
    x2: 390.975,
    y2: 108.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_388_674",
    x1: 393.117,
    y1: 136.12,
    x2: 384.272,
    y2: 136.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_388_674",
    x1: 392.354,
    y1: 357.164,
    x2: 384.517,
    y2: 357.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_388_674",
    x1: 502.563,
    y1: 25.0607,
    x2: 493.619,
    y2: 25.0607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_388_674",
    x1: 60.5811,
    y1: 689.24,
    x2: 52.6666,
    y2: 689.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_388_674",
    x1: 446.688,
    y1: 81.0588,
    x2: 438.858,
    y2: 81.0588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_388_674",
    x1: 222.158,
    y1: 357.142,
    x2: 777,
    y2: 357.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_388_674",
    x1: 242.289,
    y1: 633.655,
    x2: 288.647,
    y2: 633.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_388_674",
    x1: 333.252,
    y1: 246.492,
    x2: 374.145,
    y2: 246.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_388_674",
    x1: 350.764,
    y1: 259.928,
    x2: 375.837,
    y2: 259.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_388_674",
    x1: 245.096,
    y1: 228.901,
    x2: 261.97,
    y2: 228.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_388_674",
    x1: 261.906,
    y1: 271.176,
    x2: 272.077,
    y2: 271.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_388_674",
    x1: 335.797,
    y1: 108.066,
    x2: 386.183,
    y2: 108.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_388_674",
    x1: 384.041,
    y1: 136.12,
    x2: 392.886,
    y2: 136.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_388_674",
    x1: 384.805,
    y1: 357.164,
    x2: 392.641,
    y2: 357.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_388_674",
    x1: 274.595,
    y1: 25.0607,
    x2: 283.539,
    y2: 25.0607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_388_674",
    x1: 330.47,
    y1: 81.0588,
    x2: 338.3,
    y2: 81.0588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE4A6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 555,
    height: 745,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_388_674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 994,
    height: 221,
    fill: "white",
    transform: "matrix(0 1 1 0 222 -142)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLorus);
export default __webpack_public_path__ + "static/media/lorus.c24b497a72f2a4af238c82830251ec2f.svg";
export { ForwardRef as ReactComponent };